import React from 'react';
import Grid from '@mui/material/Grid2';

import { InheritAttributesEnhancement } from "@dndModels";

import InheritAttributesInput from '@dndComponents/creature/InheritAttributesInput';
import EnhancementModeBox from './EnhancementModeBox';

interface Props {
  header: string;
  value: InheritAttributesEnhancement;
  disabled: boolean;
  onChange: () => void;
}

export default function InheritAttributesEnhancementInput({
  header,
  value,
  disabled,
  onChange
}: Props) {
  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12} className="header centered">{ header }</Grid>
      <Grid size={12}>
        <EnhancementModeBox
          name="Mode"
          modes={["Leave","Replace","Add"]}
          value={value.mode}
          disabled={disabled}
          onChange={(changed) => {
            value.mode = changed as InheritAttributesEnhancement["mode"];
            onChange();
          }}
        />
      </Grid>
      <Grid size={12}>
        <InheritAttributesInput
          attributes={value.value}
          disabled={disabled || value.mode === "Leave"}
          onChange={onChange}
        />
      </Grid>
    </Grid>
  );
}
